<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith unselectable">
  <div class="unselectable headerTitle headline">Auswertungen</div>
  <div class="breakLine"></div>
  <div id="datePicker" class="inputContent">
    <mat-form-field appearance="fill">
      <mat-label>Auswertungsdatum</mat-label>
      <mat-date-range-input [rangePicker]="picker" (selectionchange)="loadData()">
        <input matStartDate placeholder="Startdatum" [(ngModel)]="startDate">
        <input matEndDate placeholder="Enddatum" [(ngModel)]="endDate">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-raised-button color="primary" id="loadButton" (click)="loadData()">Laden</button>
  </div>
  <div id="moduleContent">
    <mat-tab-group>
      <mat-tab label="Verursacher">
        <div class="matTabContent">
          <ejs-grid
            #employeeGrid
            id="employeeGrid"
            [dataSource]="employeeDataSource"
            [columns]="employeeColumns"
            [editSettings]="editSettings"
            [toolbar]="toolbar"
            [allowPaging]="allowances"
            [allowExcelExport]="allowances"
            [allowPdfExport]="allowances"
            (toolbarClick)="onToolbarClick($event)"
            [childGrid]="employeeChildGrid">
          </ejs-grid>
        </div>
      </mat-tab>
      <mat-tab label="Empfänger">
        <div class="matTabContent">
          <ejs-grid
            #receiverGrid
            id="receiverGrid"
            [dataSource]="receiverDataSource"
            [columns]="receiverColumns"
            [editSettings]="editSettings"
            [toolbar]="toolbar"
            [allowPaging]="allowances"
            [allowExcelExport]="allowances"
            [allowPdfExport]="allowances"
            (toolbarClick)="onToolbarClick($event)"
            [childGrid]="receiverChildGrid">
          </ejs-grid>
        </div>
      </mat-tab>
      <mat-tab label="Importeur">
        <div class="matTabContent">
          <ejs-grid
            #importerGrid
            id="importerGrid"
            [dataSource]="importerDataSource"
            [columns]="importerColumns"
            [editSettings]="editSettings"
            [toolbar]="toolbar"
            [allowPaging]="allowances"
            [allowExcelExport]="allowances"
            [allowPdfExport]="allowances"
            (toolbarClick)="onToolbarClick($event)"
            [childGrid]="importerChildGrid">
          </ejs-grid>
        </div>
      </mat-tab>
      <mat-tab label="Auftragstyp">
        <div class="matTabContent">
          <ejs-grid
            #jobTypeGrid
            id="jobTypeGrid"
            [dataSource]="jobTypeDataSource"
            [columns]="jobTypeColumns"
            [editSettings]="editSettings"
            [toolbar]="toolbar"
            [allowPaging]="allowances"
            [allowExcelExport]="allowances"
            [allowPdfExport]="allowances"
            (toolbarClick)="onToolbarClick($event)"
            [childGrid]="jobTypeChildGrid">
          </ejs-grid>
        </div>
      </mat-tab>
      <mat-tab label="Schäden verursacht durch Mitarbeiter">
        <div class="matTabContent">
          <div class="inputContent">
            <mat-form-field class="customFormField">
              <mat-select #employeeSelect [formControl]="employeeFormControl" multiple placeholder="Verursacher..." (closed)="getCausedByChart()" [disabled]="disabledMultiSelects">
                <mat-option [value]="0" (click)="toggleAllEmployeesSelection()">Alle</mat-option>
                <mat-option *ngFor="let employee of employeeList" [value]="employee.UniqueId">{{employee.LastName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ejs-accumulationchart
            id="causedByChartContainer"
            [enableSmartLabels]="enableSmartLabels"
            [legendSettings]="legendSettings"
            (pointClick)="onPointClick($event)">
            <e-accumulation-series-collection>
              <e-accumulation-series
                startAngle="0"
                endAngle="360"
                innerRadius="30%"
                name="Anzahl Schäden"
                explode="true"
                explodeOffset="10%"
                type="Pie"
                [dataSource]="causedByChartDataSource"
                [pointColorMapping]="map"
                [dataLabel]="dataLabel"
                xName="xValue"
                yName="yValue">
              </e-accumulation-series>
            </e-accumulation-series-collection>
          </ejs-accumulationchart>
        </div>
      </mat-tab>
      <mat-tab label="Schäden gemeldet vom Empfänger">
        <div class="matTabContent">
          <div class="inputContent">
            <mat-form-field class="customFormField">
              <mat-select #receiverSelect [formControl]="receiverFormControl" multiple placeholder="Empfänger..." (closed)="getReceiverChart()" [disabled]="disabledMultiSelects">
                <mat-option [value]="0" (click)="toggleAllReceiversSelection()">Alle</mat-option>
                <mat-option *ngFor="let receiver of receiverList" [value]="receiver.ReceiverId">{{receiver.ReceiverName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ejs-accumulationchart
            id="receiverChartContainer"
            [enableSmartLabels]="enableSmartLabels"
            [legendSettings]="legendSettings"
            (pointClick)="onPointClick($event)">
            <e-accumulation-series-collection>
              <e-accumulation-series
                startAngle="0"
                endAngle="360"
                innerRadius="30%"
                name="Anzahl Schäden"
                explode="true"
                explodeOffset="10%"
                type="Pie"
                [dataSource]="receiverChartDataSource"
                [pointColorMapping]="map"
                [dataLabel]="dataLabel"
                xName="xValue"
                yName="yValue">
              </e-accumulation-series>
            </e-accumulation-series-collection>
          </ejs-accumulationchart>
        </div>
      </mat-tab>
      <mat-tab label="Schäden nach Automarken">
        <div class="matTabContent">
          <div class="inputContent">
            <mat-form-field class="customFormField">
              <mat-select #brandSelect [formControl]="brandFormControl" multiple placeholder="Marke..." (closed)="getBrandChart()" [disabled]="disabledMultiSelects">
                <mat-option [value]="0" (click)="toggleAllBrandsSelection()">Alle</mat-option>
                <mat-option *ngFor="let brand of brandList" [value]="brand.CarBrandId">{{brand.CarBrandName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ejs-accumulationchart
            id="brandChartContainer"
            [enableSmartLabels]="enableSmartLabels"
            [legendSettings]="legendSettings"
            (pointClick)="onPointClick($event)">
            <e-accumulation-series-collection>
              <e-accumulation-series
                startAngle="0"
                endAngle="360"
                innerRadius="30%"
                name="Anzahl Schäden"
                explode="true"
                explodeOffset="10%"
                type="Pie"
                [dataSource]="brandChartDataSource"
                [pointColorMapping]="map"
                [dataLabel]="dataLabel"
                xName="xValue"
                yName="yValue">
              </e-accumulation-series>
            </e-accumulation-series-collection>
          </ejs-accumulationchart>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<app-footer></app-footer>
